import type { UseCase } from '@cleanpro/common-ui';
import { CustomerRepository } from '../repositories/CustomerRepository';

interface DeleteCustomerRequest {
  id: string;
}

interface DeleteCustomerResponse {
  success: boolean;
}

export class DeleteCustomerUseCase implements UseCase<DeleteCustomerRequest, DeleteCustomerResponse> {
  constructor(private customerRepository: CustomerRepository) {}

  async execute(request: DeleteCustomerRequest): Promise<DeleteCustomerResponse> {
    // Verify customer exists
    const customer = await this.customerRepository.findById(request.id);
    if (!customer) {
      throw new Error('Customer not found');
    }

    // Delete customer
    await this.customerRepository.delete(request.id);

    return { success: true };
  }
}